import React, { useState, useEffect } from "react";
import CircularLoading from "../loading/Loading";
import "./MilstoneTrackerView.css";
import { useNavigate } from "react-router-dom";

const MilestoneTrackerView = ({ pediatricianId, patientId }) => {
  const [milestones, setMilestones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("s2stoken");
  const navigate = useNavigate()

  useEffect(() => {
    const fetchMilestones = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/get_milestone_tracker_doctor_view?pediatrician_id=${pediatricianId}&patient_id=${patientId}`,
          {
            method: "GET",
            credentials: "include",
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = await response.json();
        if (!response.ok || data.success === false) {
          throw new Error(data.message || "Failed to fetch data");
        }

        if (data.success) {
          setMilestones(
            data.data
              .filter(
                (milestone) =>
                  milestone["Milestone Check"] === "yes" ||
                  milestone["Red Flag Check"] === "yes"
              )
              .map((milestone) => ({
                ...milestone,
                Milestone:
                  milestone["Milestone Check"] === "yes"
                    ? milestone.Milestone
                    : "-",
                "Red Flag":
                  milestone["Red Flag Check"] === "yes"
                    ? milestone["Red Flag"]
                    : "-",
              }))
          );
        } else {
          alert(data.message);
        }
      } catch (error) {
         if (error?.message === 'Token has expired') {
          localStorage.removeItem('s2stoken')
          navigate('/')
        }
        console.error("Error fetching milestone data:", error);
        alert("Error fetching milestone data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchMilestones();
  }, [pediatricianId, patientId]);

  if (isLoading) {
    return <CircularLoading />;
  }

  return (
    <div className="milestone-tracker-view">
      <h1>Milestone Tracker</h1>
      <table>
        <thead>
          <tr>
            <th>Age Range</th>
            <th>When to Complete</th>
            <th>Milestone</th>
            <th>Red Flag</th>
          </tr>
        </thead>
        <tbody>
          {milestones.map((milestone, index) => (
            <tr key={index}>
              <td data-label="Age Range">{milestone["Age Range"]}</td>
              <td data-label="When to Complete">
                {milestone["When to Complete"]}
              </td>
              <td data-label="Milestone">{milestone.Milestone}</td>
              <td className="red-flag" data-label="Red Flag">
                {milestone["Red Flag"] || ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MilestoneTrackerView;
